

































































































































import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
// import * as models from '@/class/models/views/app';
import * as models from '@/class/models/views/graph';
import * as models_app from '@/class/models/views/app';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import ClickOutside from 'vue-click-outside';

interface Data {
  modalShowFlag2: boolean;
  navHover: boolean;
  navHover2: boolean;
  navHover3: boolean;
  newNewsCount: string;
}
interface Methods {
  onDetailModalClose: () => void;
  onAnotherModal: () => void;
  onPushPath: (path: string) => void;
  newsCount: () => string;
  activeClass: (path: string) => string;
  onClickShowGadgetEditer: () => void;
  onClickShowAddGadget: () => void;
  onClickSPMenuOutSide: () => void;
}
interface Computed {
  DISP_ROLE: string;
  urlTop: boolean;
  AVAILABLE_CONTRACT: boolean;
}
interface Props {
  appData: models_app.IAPP;
  dispClick: boolean;
  ownerFlag: boolean;
  newsList: [];
  alertCount: number;
  nowPath: string;
}

export default Vue.extend({
  name: 'TopBar',
  props: {
    appData: Object as PropOptions<models_app.IAPP>,
    dispClick: Boolean,
    ownerFlag : Boolean,
    newsList: Array,
    alertCount: Number,
    nowPath: String,
  },
  data() {
    return {
      // modalShowFlag: false,
      modalShowFlag2: false,
      navHover: false,
      navHover2: false,
      navHover3: false,
      // roleText: '',
      newNewsCount: '0',
    };
  },
  computed: {
    DISP_ROLE(): string {
      return NOCArray.getOptionsText(NOCArray.ROLE, this.appData.role);
    },
    urlTop() {
      return this.$route.path === '/';
    },
    AVAILABLE_CONTRACT(): boolean {
      switch (this.appData.contractStatus) {
        case NOC.CONTRACT.QUIT:
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
        case NOC.CONTRACT.DENY:
          return false;
        default:
          return true;
      }
    },
  },
  watch: {
    dispClick() {
      this.onDetailModalClose();
    },
    // $route(to, from) {
    //   if (to.path !== from.path) {
    //     this.$data.modalShowFlag = false;
    //   }
    // },
    newsList: {
      deep: true,
      handler(newValue, oldInput) {
        let count = String(this.newsList.filter((v: any) => (v.checked === false)).length);
        if (Number(count) > 99) {
          count = '99+';
        }
        this.newNewsCount = count;
      },
    },
  },
  directives: {
    ClickOutside,
  },
  methods: {
    onDetailModalClose() {
      // this.modalShowFlag = false;
      this.modalShowFlag2 = false;
    },
    onAnotherModal() {
      this.modalShowFlag2 = false;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {});
      this.$emit('pushPath', path);
      this.onDetailModalClose();
    },
    newsCount() {
      let count = String(this.newsList.length);
      if (Number(count) > 99) {
        count = '99+';
      }
      return count;
    },
    activeClass(path: string) {
      return this.nowPath.indexOf(path) > -1 ? 'active' : '';
    },
    onClickShowGadgetEditer() {
      this.$emit('edit', new models.CGadget());
      this.$emit('openGadget');
    },
    onClickShowAddGadget() {
      this.$emit('openAdd');
    },
    onClickSPMenuOutSide() {
      this.modalShowFlag2 = false;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);

